import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "./lib/auth";
import { ThemeProvider } from "./lib/theme";

import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Status from "./pages/Status";
import Abuse from "./pages/Abuse";
import LegalPage from "./pages/legal/LegalPage";
import Product from "./pages/Product";
import Solution from "./pages/Solution";
import Industry from "./pages/Industry";
import WhyArgus from "./pages/WhyArgus";
import Resources from "./pages/Resources";
import About from "./pages/About";
import Customers from "./pages/Customers";
import Demo from "./pages/Demo";
import DocsSetup from "./pages/DocsSetup";
import Landscape from "./pages/Landscape";
import Trust from "./pages/Trust";

import Welcome from "./pages/app/Welcome";
import Dashboard from "./pages/app/Dashboard";
import Projects from "./pages/app/Projects";
import ProjectDetail from "./pages/app/ProjectDetail";
import Scans from "./pages/app/Scans";
import Findings from "./pages/app/Findings";
import Reports from "./pages/app/Reports";
import Settings from "./pages/app/Settings";
import Integrations from "./pages/app/Integrations";
import Admin from "./pages/Admin";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PlatformOverview from "./pages/PlatformOverview";
import GoddyAgent from "./components/argus/GoddyAgent";

function Protected({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider defaultMode="dark">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" theme="system" />
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/products/:slug" element={<Product />} />
          <Route path="/solutions/:slug" element={<Solution />} />
          <Route path="/industries/:slug" element={<Industry />} />
          <Route path="/why-argus" element={<WhyArgus />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:slug" element={<Resources />} />
          <Route path="/landscape" element={<Landscape />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/docs/setup" element={<DocsSetup />} />
          <Route path="/docs" element={<Navigate to="/docs/setup" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/status" element={<Status />} />
          <Route path="/trust" element={<Trust />} />
          <Route path="/abuse" element={<Abuse />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/platform" element={<PlatformOverview />} />

          <Route path="/app/welcome" element={<Protected><Welcome /></Protected>} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/projects" element={<Protected><Projects /></Protected>} />
          <Route path="/app/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
          <Route path="/app/scans" element={<Protected><Scans /></Protected>} />
          <Route path="/app/findings" element={<Protected><Findings /></Protected>} />
          <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/app/integrations" element={<Protected><Integrations /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <GoddyAgent />
      </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
